import { useParams } from "react-router";
import DropdownMenu from "../../component/DropdownMenu";
import Footer from "../../component/Footer";
import Navbar from "../../component/Navbar";

import { DataCenter_1, DataCenter_2, DataCenter_3 } from "../../inc/DataCenter";

const centerComponents = {
  1: DataCenter_1,
  2: DataCenter_2,
  3: DataCenter_3,
};

export default function Page() {
  const { id } = useParams();
  const Component = centerComponents[id];

  return (
    <>
      <Navbar />
      <DropdownMenu />
      <div className="relative">
        <div className="max-w-5xl mx-auto container h-full">
          {Component ? <Component /> : <span>ไม่พบข้อมูล</span>}
        </div>
      </div>
      <Footer />
    </>
  );
}
